import { useState } from "react";





export default function TextField({
    name, 
    initialValue, 
    placeholder, 
    label, 
    changeCallback,
    className,
    focusRef,
    required = false,
}){
    const [value, setValue] = useState(initialValue);;

    const handleChange = (e) => {
        setValue(e.target.value);
        changeCallback(e);
    }


    return (
        <>
            <label
                className={`
                    flex
                    flex-col
                    font-semibold
                    text-xl
                    tracking-wider

                    text-body-text-light
                    dark:text-body-text-dark
                    ${
                        className
                    }
                `}
            >
                {label}
                <input 
                    ref={focusRef}
                    className="
                        mt-5
                        text-base
                        font-normal
                        tracking-wider

                        text-body-text-light
                        dark:text-body-text-dark

                        px-4
                        py-4
                        border-0
                        border-b-2
                        border-transparent
                        focus:outline-none
                        focus:border-0
                        focus:border-b-2
                        focus:border-body-text-light
                        dark:focus:border-body-text-dark
                        transition-colors
                        duration-300
                        ease-in-out
                        rounded-none
                    "
                    aria-label={label}
                    type="text" 
                    value={value}
                    name={name}
                    placeholder={placeholder}
                    onChange={handleChange}
                    required={required}
                />
            </label>
        </>
    );

};